import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

type Column = {
  name?: React.ReactNode;
  width?: string | number;
};

interface TableSkeletonProps {
  columns: Column[];
  sidebarOpen?: boolean;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({
  columns,
  sidebarOpen = false,
}) => {
  return (
    <div
      style={{
        width: !sidebarOpen ? "calc(100vw - 165px)" : "calc(100vw - 326px)",
        background: "white",
        display: "flex",
        flexDirection: "column",
        alignContent: "flex-start",
        maxHeight: "calc(100vh - 15.75rem)",
        overflow: "hidden",
      }}
    >
      <div>
        {Array.from({ length: 11 }).map((_, i) => (
          <div
            key={i + 1}
            style={{
              padding: "0 16px",
              height: "52px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              borderBottom: "1px solid rgba(241, 243, 249, 0.50)",
            }}
          >
            {columns?.map((column, columnIndex) => (
              <div
                key={columnIndex}
                style={{ width: column.width || "100px", flexShrink: 0 }}
              >
                <Skeleton height="25px" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TableSkeleton;
